import React from 'react';
import Grappa from "../../../assets/images/Grappa.png";
import Hobby from "../../../assets/images/Hobby.png";
import Potstill from "../../../assets/images/Potstill.png";
import Professional from "../../../assets/images/Professional.png";
import Rectifier from "../../../assets/images/Rectifier.png";
import { useTranslation } from 'react-i18next';

function Destiller() {
  const { t } = useTranslation();

  const products = [
    { 
      name: t('Grappa'),
      description: t('Grappa is an Italian traditional beverage, the methodology of which can be achieved with the help of this distiller, it provides a high quality product rich in aromas.'),
      image: Grappa, 
    },
    { 
      name: t('Hobby'),
      description: t('Distilling is a very fun activity, our small multi-practical product is intended for the production of all types of drinks and essential oils under any circumstances'),
      image: Hobby,
    },
    { 
      name: t('Pot Still'),
      description: t('Pot stills are used for the distillation of grappa and fruit distillates. All parts of the device that come into contact with the fermented fruit mash, steam, or the distillate itself, are made of the highest quality electrolytic copper, that is resistant to the action of organic acids and ensures the purity of the aroma and taste of the product.'),
      image: Potstill,
    },
    { 
      name: t('Professional'),
      description: t('A combination of every industrial element, which will allow you to produce any kind of product of your liking. A very quality-oriented system.'),
      image: Professional,
    },
    { 
      name: t('Rectifier'),
      description: t('Rectification is any process or procedure whereby distilled spirits are cut, blended, mixed or infused with any ingredient. Des rectifier enables to further enhance your product’s quality.'),
      image: Rectifier,
    },
  ];

  return (
    <div className='main-infocontainer'>
      {products.map((product, index) => (
        <div className='item-container' key={index}>
          <img src={product.image} alt={product.name} />
          <div className='text-info'>
            <h1>{product.name}</h1>
            <p>{product.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Destiller;
